import { render, staticRenderFns, recyclableRender, components } from "./bindmobile.vue?vue&type=template&id=01a24904&"
var renderjs
import script from "./bindmobile.vue?vue&type=script&lang=js&"
export * from "./bindmobile.vue?vue&type=script&lang=js&"
import style0 from "./bindmobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/login/bindmobile.vue"
export default component.exports